import { nextTick } from 'vue';

// Global navigation state
let isNavigating = false;
let navigationTimeout = null;

export default {
  install(app, options = {}) {
    const { debounceTime = 300 } = options;
    const router = app.config.globalProperties.$router;
    
    // Add global navigation guard
    router.beforeEach(async (to, from, next) => {
      // Clear any pending navigation timeout
      if (navigationTimeout) {
        clearTimeout(navigationTimeout);
      }
      
      // If already navigating, block
      if (isNavigating) {
        console.log('Navigation blocked - already navigating');
        next(false);
        return;
      }
      
      // Set navigating state
      isNavigating = true;
      
      // Wait for DOM updates
      await nextTick();
      
      // Continue navigation
      next();
    });
    
    // Reset navigation state after navigation completes
    router.afterEach(() => {
      navigationTimeout = setTimeout(() => {
        isNavigating = false;
      }, debounceTime);
    });
    
    // Add global method for safe navigation
    app.config.globalProperties.$safeNavigate = async (path) => {
      if (isNavigating) {
        console.log('Navigation blocked - already navigating');
        return false;
      }
      
      try {
        await router.push(path);
        return true;
      } catch (error) {
        console.error('Navigation error:', error);
        return false;
      }
    };
    
    // Add directive for preventing multiple clicks
    app.directive('prevent-double-click', {
      mounted(el, binding) {
        let isProcessing = false;
        const delay = binding.arg || 300;
        
        const handleClick = async (event) => {
          if (isProcessing) {
            event.preventDefault();
            event.stopPropagation();
            return;
          }
          
          isProcessing = true;
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.6';
          
          try {
            if (typeof binding.value === 'function') {
              await binding.value(event);
            }
          } finally {
            setTimeout(() => {
              isProcessing = false;
              el.style.pointerEvents = '';
              el.style.opacity = '';
            }, delay);
          }
        };
        
        el._handleClick = handleClick;
        el.addEventListener('click', handleClick);
      },
      
      unmounted(el) {
        if (el._handleClick) {
          el.removeEventListener('click', el._handleClick);
          delete el._handleClick;
        }
      }
    });
  }
};